<template>
  <div
    ref="navBarContainer"
    :class="$style.container"
  >
    <JumpcloudBrandmark
      v-if="showJcLogo"
      :class="$style.logoImg"
      type="jcLogoWordmark"
    />
    <img
      v-else-if="logoImg"
      alt="logo"
      :class="$style.logoImg"
      :src="logoImg"
    >
    <div :class="$style.dropdown">
      <DropDownMenu
        :locationLabel="locationLabel"
        :menuSections="menuSections"
        :menuTitle="dropdownMenuTitle"
        menuFontSize="medium"
      />
    </div>
  </div>
</template>

<script>
/**
 * @todo menu action could be href="mailto:<email-address>"
 * @todo menu action could be a launch command so set org id and
 * then call "this.viewport.redirect('#/users')"
 */

import { JumpcloudBrandmark } from '@jumpcloud/ui-components';
import DropDownMenu from 'client/components/DropDownMenu/DropDownMenu.vue';

export default {
  name: 'NavigationBar',

  components: {
    DropDownMenu,
    JumpcloudBrandmark,
  },

  props: {
    dropdownMenuTitle: {
      default: 'Menu Title',
      required: true,
      type: String,
    },
    locationLabel: {
      default: '',
      type: String,
    },
    logoImg: {
      default: '',
      type: String,
    },
    menuSections: {
      required: true,
      type: Array,
    },
    showJcLogo: Boolean,
  },
};
</script>

<style scoped module>
@value (jcGrey200, jcGrey900) from '~css/brand-colors.css';
@value (headerHeight) from '~css/layout.css';
@value (dropDownMenuZIndex) from '~css/z-index.css';

.container {
  align-items: center;
  background-color: white;
  border-bottom: 1px solid jcGrey200;
  color: jcGrey900;
  display: flex;
  font-size: 20px;
  height: headerHeight;
  justify-content: space-between;
  padding-left: 20px;
  z-index: dropDownMenuZIndex;
}

.dropdown {
  display: flex;
  height: headerHeight;
  justify-content: flex-end;
  position: relative;
  text-align: right;
  top: 0;
}

.logoImg {
  fill: currentColor;
  flex: 0 0 auto;
  height: 25px;
  position: relative;
  width: auto;
}

.logoImg:focus {
  outline: none;
}
</style>
